import React, { useEffect, useMemo } from 'react';
import { notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setError, setInfo, setMessage } from '../../store/common/generalSlice';
import { connectivityCheck } from '../../config/utils/ConnectivityCheck';
import { Link, useNavigate } from 'react-router-dom';
import { setNavigateToChannel } from '../../store/common/chatSlice';

const Context = React.createContext({
    name: 'Default',
});
const Toast = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { loading, error, message, errorData, info } = useSelector(state => state.general)

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (type, placement, msg) => {
        if (type == 'Error') {
            let connected = connectivityCheck();
            if (!connected) {
                return api.error({
                    message: type,
                    description: <Context.Consumer>{() => 'No internet connection'}</Context.Consumer>,
                    placement,
                    // showProgress: true,
                    pauseOnHover: true
                });
            }
            api.error({
                message: type,
                description: <Context.Consumer>{() => `${msg}`}</Context.Consumer>,
                placement,
                // showProgress: true,
                pauseOnHover: true
            });
        }
        else if (type == 'Success') {
            api.success({
                message: type,
                description: <Context.Consumer>{() => `${msg}`}</Context.Consumer>,
                placement,
                // showProgress: true,
                pauseOnHover: true
            });
        }
        else if (type == 'Info') {
            api.info({
                message: type,
                description: <Context.Consumer>{() => `${msg}`}</Context.Consumer>,
                placement,
                // showProgress: true
            });
        }
    };
    const contextValue = useMemo(
        () => ({
            name: 'Ant Design',
        }),
        [],
    );

    const handleInfoClick = () => {
        if(info && info.includes('new message')){
            dispatch(setNavigateToChannel(true))
            navigate('/chats')
        }
    }

    useEffect(() => {
        if (message) openNotification('Success', 'topRight', message)
        if (error) openNotification('Error', 'topRight', error)
        if (info) openNotification('Info', 'topRight', info)

        setTimeout(() => {
            dispatch(setMessage(''))
            dispatch(setError(''))
            dispatch(setInfo(''))
        }, 3000);
    }, [error, message, info])    

    return (
        <Context.Provider value={contextValue}>
            <div onClick={handleInfoClick}>
                {contextHolder}
            </div>
        </Context.Provider>
    );
};
export default Toast;


